<div>
	<div #picture class="block no-margins no-padding" >
		<p>&nbsp;</p>
	</div>
</div>